import http from "@/shared/http/http";
import { createTasksApi } from "./createTasksApi.mjs";

export const tasksApi = createTasksApi(http);
